import { useHistory } from 'react-router-dom';
import { Row, Col, Button } from 'antd';
import styles from './Header.module.css';
import arrowSvg from '../images/arrow_left.svg';
import tutorPng from '../images/tutor.png';

const Header = () => {
  const history = useHistory();

  return (
    <Col span={24} style={{ backgroundColor: '#fff' }}>
      <Row
        align="middle"
        justify="space-between"
        className={styles.headerWrapper}
      >
        <Button onClick={() => history.goBack()} className={styles.arrowBtn}>
          <img alt="arrow" src={arrowSvg} />
        </Button>
        <Col className={styles.headerTitle}>
          <p>AI 진단 페이지</p>
        </Col>
        <Col>
          <Row justify="space-between">
            <Col pull={1} className={styles.tutorImg}>
              <img alt="tutor img" width="48px" height="48px" src={tutorPng} />
            </Col>
            <Col justify="space-between" className={styles.tutorInfo}>
              <div className={styles.tutorName}>김지혜 선생님</div>
              <div className={styles.tutorSubject}>
                수학은 모든 공부의 시작!
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

export default Header;
